import {entries, sortBy} from "lodash";
import {groupBy} from "lodash/collection";
import {format, isToday, parse} from "date-fns";

const dateFormat = 'dd.MM.yyyy';

export const groupMessages = (messages) => sortBy(
    entries(groupBy(messages, (message) => {
        console.log('message', message)
        console.log('messages', messages)
        console.log('message.timestamp', message.timestamp)
        if(message.timestamp === undefined) return
        const date = new Date(message.timestamp);
        console.log('date', date)
        return format(date, dateFormat);
    })),
    ([date,]) => {
        return parse(date)
    },
).reverse().map(([date, messages]) =>
    [
        isToday(parse(date, dateFormat, new Date())) ? 'Сегодня' : date,
        sortBy(messages, 'timestamp')
    ]
);

export const getLastMessage = (groupedMessages) => {
    if (groupedMessages.length === 0) return undefined;

    const [, messages] = groupedMessages[groupedMessages.length - 1];

    if (messages.length === 0) return undefined;

    return messages[messages.length - 1];
}

export const checkIsBotTyping = (groupedMessages) => {
    return getLastMessage(groupedMessages)?.isLocal ?? false;
}